import { generatePath } from 'react-router-dom';
import { DebtorSetting } from '../../contexts/DebtorAccountContext.types';
import { ApiRoutes } from '../apiRoutes';
import { oktaGet } from '../oktaRequestWrapper';

export const getDebtorSettingsAsync = async (
  debtorId: number,
): Promise<DebtorSetting> => {
  const route = generatePath(ApiRoutes.DebtorSettings, {
    debtorId: debtorId.toString(),
  });
  const response = await oktaGet<DebtorSetting>(route);
  return response.data;
};
